// @flow
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Row, Col, Button, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../dashboard/Dashboard/Dashboard.css';
// components
import { FormInput } from '../../components/';
import { useSelector, useDispatch } from 'react-redux';

import { Loading } from 'react-loading-ui';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import { yupResolver } from '@hookform/resolvers/yup';
import { getUserProfile, updateProfile } from '../../API/RDPMS_API';
import { APICore } from '../../helpers/api/apiCore';
import { handleUserLogin } from '../../utils/ColumnUtils';
import * as bootstrap from 'bootstrap'; // For success modal

const api = new APICore();

const PersonalInfo = ({ register, errors, control }) => {
    const { t } = useTranslation();
    return (
        <>
            <h5 className="mb-4 text-uppercase">
                <i className="mdi mdi-account-circle me-1"></i> {t('Personal Info')}
            </h5>

            <div className="row">
                {/* First Row: Full Name and Contact */}
                <div className="col-md-6 mb-3">
                    <FormInput
                        label={t('Full Name')}
                        type="text"
                        name="name"
                        placeholder={t('Enter full name')}
                        containerClass={'mb-3'}
                        register={register}
                        key="name"
                        errors={errors}
                        control={control}
                        className="form-control"
                        onInput={(e) => {
                            e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '');
                        }}
                    />
                </div>
                <div className="col-md-6 mb-3">
                    <FormInput
                        label={t('Contact')}
                        type="text"
                        name="contact"
                        placeholder={t('Enter contact')}
                        containerClass={'mb-3'}
                        register={register}
                        key="contact"
                        errors={errors}
                        control={control}
                        className="form-control"
                        maxLength={10}
                        onInput={(e) => {
                            e.target.value = e.target.value.replace(/[^0-9]/g, '');
                        }}
                    />
                </div>
            </div>

            <div className="row">
                {/* Second Row: Location and Email */}
                <div className="col-md-6 mb-3">
                    <FormInput
                        label={t('Location Name')}
                        type="text"
                        name="location"
                        placeholder={t('Enter location')}
                        containerClass={'mb-3'}
                        register={register}
                        key="location"
                        errors={errors}
                        control={control}
                        className="form-control"
                        onInput={(e) => {
                            e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '');
                        }}
                    />
                </div>
                <div className="col-md-6 mb-3">
                    <FormInput
                        label={t('Email')}
                        type="text"
                        name="email"
                        placeholder={t('Enter email')}
                        register={register}
                        key="email"
                        errors={errors}
                        control={control}
                        className="form-control"
                        disabled
                    />
                </div>
                {/* <Row>
                <Col md={6} className="mb-3">
                    <span className="form-text text-muted">
                        <small>
                            {t('If you want to change password please')}{' '}
                            <Link to="/account/forget-password">{t('click')}</Link> {t('here')}.
                        </small>
                    </span>
                </Col>
            </Row> */}
            </div>
        </>
    );
};

const Settings = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [showErrorModal, setShowErrorModal] = useState(false); // State for error modal

    const { auth } = useSelector((state) => ({
        auth: state.Auth,
    }));

    const id = auth && auth.user && auth.user._id && auth.user._id;
    const role = auth && auth.user && auth.user.role && auth.user.role;
    const name = auth && auth.user && auth.user.name && auth.user.name;
    const contact = auth && auth.user && auth.user.contact && auth.user.contact;
    const email = auth && auth.user && auth.user.email && auth.user.email;
    const location = auth && auth.user && auth.user.location && auth.user.location;
    const password = auth && auth.user && auth.user.location && auth.user.password;

    const schema = yup
        .object()
        .shape({
            name: yup.string().required(t('Please enter name')),
            contact: yup.string().min(10).max(10).required(t('Please enter mobile number')),
            email: yup.string().required(t('Please enter email address')),
            location: yup.string().required(t('Please enter location')),
        })
        .required();

    const methods = useForm({
        defaultValues: {
            name: name,
            role: role,
            contact: contact,
            email: email,
            location: location,
            password: password,
        },
        resolver: yupResolver(schema),
    });

    const {
        register,
        control,
        formState: { errors },
        handleSubmit,
    } = methods;

    const handleUserData = async (formData) => {
        formData.id = id;
        formData.role = role;
        formData.password = password;

        Loading();
        let result = await updateProfile(formData);
        if (result) {
            const user = await getUserProfile(id);
            if (user) {
                handleUserLogin(dispatch, api, user);
            }

            // Show success modal
            const modalElement = document.getElementById('updateStation');
            const modal = new bootstrap.Modal(modalElement);
            modal.show();
        } else {
            // Show error modal instead of toast
            setShowErrorModal(true);
        }
        Loading();
    };

    const closeErrorModal = () => {
        setShowErrorModal(false);
    };

    return (
        <>
            <ToastContainer />
            <form onSubmit={handleSubmit(handleUserData)} className="px-4">
                <PersonalInfo register={register} errors={errors} control={control} />

                <div className="text-end">
                    <Button
                        type="submit"
                        className="btn btn-edit-profile"
                        style={{
                            backgroundColor: '#ffc107',
                            color: 'rgb(0, 0, 0)',
                            fontWeight: 600,
                            borderRadius: '8px',
                            padding: '10px 20px',
                            cursor: 'pointer',
                            border: 'none',
                        }}>
                        <i className="mdi mdi-content-save"></i> Save
                    </Button>
                </div>
            </form>

            {/* Success Modal (Plain Bootstrap) */}
            <div
                className="modal fade"
                id="updateStation"
                tabIndex="-1"
                aria-labelledby="updateStationLabel"
                aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header close">
                            <button
                                type="button"
                                className="btn-close ms-auto"
                                data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                        <div className="modal-body text-center">
                            <img
                                src="/asset-images/checkmark.png"
                                alt="Success"
                                className="img-fluid"
                                style={{ maxWidth: '100px' }}
                            />
                            <p className="mt-3">{t('Profile updated successfully')}</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Error Modal (React-Bootstrap) */}
            <Modal show={showErrorModal} onHide={closeErrorModal} centered>
                <Modal.Header closeButton style={{ backgroundColor: '#D9E9FF' }}>
                    <Modal.Title>{t('Profile Update Failed')}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    <img
                        src="/asset-images/deleteiconmodal.png"
                        alt="Error"
                        className="img-fluid"
                        style={{ maxWidth: '100px' }}
                    />
                    <p className="mt-3">{t('Profile update unsuccessful. Please try again.')}</p>
                    <div className="d-flex justify-content-center">
                        <Button
                            variant="secondary"
                            onClick={closeErrorModal}
                            style={{
                                width: '100px',
                                borderRadius: '0',
                            }}>
                            {t('Close')}
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default Settings;
